import CheckIcon from "@mui/icons-material/Check";
import { Box, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

const BORDER_COLOR = "rgba(0,0,0,0.12)";

export const ScopeOfMovementColumn = ({ reassignment }: any) => {
  const { t } = useTranslation();
  const scopes: string[] = [];
  if (reassignment.isJobChange) scopes.push(t("full-time-shifts_job"));
  if (reassignment.isWorkcenterChange) scopes.push(t("full-time-shifts_work-center"));
  if (reassignment.isPatternChange) scopes.push(t("full-time-shifts_shift"));

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: 1,
        justifyContent: "flex-start",
        borderRight: `1px solid ${BORDER_COLOR}`,
        minWidth: "187px",
        maxWidth: "187px",
        height: "116px",
        padding: "8px",
      }}
    >
      {scopes.map(scope => (
        <Box
          key={scope}
          sx={{
            display: "flex",
            alignItems: "center",
            flexDirection: "row",
            justifyContent: "flex-start",
            gap: 0.5,
            fontSize: "14px",
            fontFamily: "Roboto",
            color: "rgba(0,0,0,0.87)",
          }}
        >
          <CheckIcon sx={{ color: "green", width: 16, height: 16 }} />
          <Typography>{scope}</Typography>
        </Box>
      ))}
    </Box>
  );
};